import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { Tooltip as r } from "../Tooltip/index.js";
import { forwardRef as k, createElement as n } from "react";
var x = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};
const C = (o, l, c, m) => {
  const i = k(
    ({ color: h = "currentColor", size: s = 24, stroke: p = 2, title: a, className: d, children: e, ...w }, g) => n(
      "svg",
      {
        ref: g,
        ...x[o],
        width: s,
        height: s,
        className: ["tabler-icon", `tabler-icon-${l}`, d].join(" "),
        strokeWidth: p,
        stroke: h,
        ...w
      },
      [
        a && n("title", { key: "svg-title" }, a),
        ...m.map(([u, v]) => n(u, v)),
        ...Array.isArray(e) ? e : [e]
      ]
    )
  );
  return i.displayName = `${c}`, i;
};
const y = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M12 9v4", key: "svg-1" }], ["path", { d: "M12 16v.01", key: "svg-2" }]], N = C("outline", "exclamation-circle", "ExclamationCircle", y), E = ({ children: o }) => /* @__PURE__ */ f(r, { children: [
  /* @__PURE__ */ t(r.Trigger, { children: /* @__PURE__ */ t("span", { className: "cursor-pointer", children: /* @__PURE__ */ t(N, { className: "w-4 h-4" }) }) }),
  /* @__PURE__ */ t(r.Content, { className: "tooltip-content", children: o })
] });
export {
  E as InfoIcon,
  E as default
};
